var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropdownQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    viewBox: "0 0 16 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.176 1.80925L8.35098 8.34853C8.12241 8.54139 7.90812 8.61996 7.72598 8.61996C7.54384 8.61996 7.29848 8.54071 7.13348 8.3811L0.276337 1.80925C-0.0663771 1.48425 -0.07752 0.909246 0.250623 0.598532C0.576516 0.254782 1.12134 0.243604 1.46169 0.572864L7.72598 6.5771L13.9903 0.577103C14.3296 0.247853 14.8753 0.259032 15.2013 0.602771C15.5296 0.909247 15.5188 1.48425 15.176 1.80925Z",
    fill: "#0E7490"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownQuestion);
export default __webpack_public_path__ + "static/media/dropdown-question.4842266f10730eea6213e7d129ead118.svg";
export { ForwardRef as ReactComponent };